import { device } from '@/components/templates/displays/devices'
import * as React from 'react'
import { ICar, IGalleryImage } from 'shared-interfaces'
import styled from 'styled-components'
import FullWidthImageMobile from '../../../atoms/images/fullWidthImageMobile'

const Wrap = styled.section<IStyle>`
    width: 100%;
    height: 100%;
`

const Title = styled.div`
    font-family: Lato;
    font-size: 0.92rem;
    padding-right: 20px;
    color: #2a979a;

    @media ${device.ipad} {
        font-size: 1.1rem;
    }
`

const WrapPadding = styled.div`
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    @media ${device.ipad} {
        padding-left: 20px;
    }
`

const CarDescription = styled.div`
    line-height: 20px;
    text-align: left;
    font-size: 13px;
    padding-bottom: 0.5rem;
`

interface Props {
    item: {
        car: ICar
        cover_img: IGalleryImage | undefined
    }
}

interface IStyle {
    something?: boolean
}

const GarageBannerViewMobile: React.FunctionComponent<Props> = (props) => {
    return (
        <Wrap>
            <FullWidthImageMobile
                img={props.item.cover_img}
                carTitle={props.item.car.title}
            />
            <WrapPadding>
                <Title>{props.item.car.title}</Title>

                <div style={{ paddingBottom: '30px', paddingTop: '8px' }}>
                    <CarDescription>
                        {props.item.car.short_description}
                    </CarDescription>
                </div>
            </WrapPadding>
        </Wrap>
    )
}

export default GarageBannerViewMobile
